var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS1ElecHan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 486.68766404199476 566.5380577427821",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l486.68765 0l0 566.5381l-486.68765 0l0 -566.5381z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l486.68765 0l0 566.5381l-486.68765 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m15.364272 92.238l0 0c0 -41.66137 33.77321 -75.434586 75.43458 -75.434586l301.72925 0l0 0c20.0065 0 39.193573 7.94755 53.3403 22.094276c14.1467285 14.1467285 22.0943 33.333813 22.0943 53.340305l0 381.94974c0 41.661377 -33.773224 75.43457 -75.4346 75.43457l-301.72925 0c-41.66137 0 -75.43458 -33.773193 -75.43458 -75.43457z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m15.364272 92.238l0 0c0 -41.66137 33.77321 -75.434586 75.43458 -75.434586l301.72925 0l0 0c20.0065 0 39.193573 7.94755 53.3403 22.094276c14.1467285 14.1467285 22.0943 33.333813 22.0943 53.340305l0 381.94974c0 41.661377 -33.773224 75.43457 -75.4346 75.43457l-301.72925 0c-41.66137 0 -75.43458 -33.773193 -75.43458 -75.43457z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m172.18636 218.7824l0 0c0 -6.763809 5.4831543 -12.2469635 12.2469635 -12.2469635l241.04938 0c3.248108 0 6.363159 1.2902985 8.659912 3.5870514c2.296753 2.296753 3.5870361 5.4118195 3.5870361 8.659912l0 48.986404c0 6.763794 -5.483124 12.246948 -12.246948 12.246948l-241.04938 0c-6.763809 0 -12.2469635 -5.4831543 -12.2469635 -12.246948z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m172.18636 218.7824l0 0c0 -6.763809 5.4831543 -12.2469635 12.2469635 -12.2469635l241.04938 0c3.248108 0 6.363159 1.2902985 8.659912 3.5870514c2.296753 2.296753 3.5870361 5.4118195 3.5870361 8.659912l0 48.986404c0 6.763794 -5.483124 12.246948 -12.246948 12.246948l-241.04938 0c-6.763809 0 -12.2469635 -5.4831543 -12.2469635 -12.246948z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m49.0 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m49.0 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m63.57626 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m63.57626 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m78.15252 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m78.15252 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m92.72878 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.72878 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m107.305046 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m107.305046 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m121.88131 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m121.88131 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m136.45757 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m136.45757 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m151.03383 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m151.03383 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m165.61009 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m165.61009 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m180.18636 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m180.18636 361.22833l0 22.771667",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m49.0 344.6378l116.44095 0.09448242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDasharray: "4.0,12.0",
    d: "m49.0 344.6378l116.44095 0.09448242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m167.3622 143.9764l0 0c0 -4.9575043 4.01886 -8.976364 8.976379 -8.976364l0 0c2.3806915 0 4.663864 0.9457092 6.3472595 2.6291199c1.6833954 1.6833954 2.6291199 3.966568 2.6291199 6.3472443l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m167.3622 143.9764l0 0c0 -4.9575043 4.01886 -8.976364 8.976379 -8.976364l0 0c2.3806915 0 4.663864 0.9457092 6.3472595 2.6291199c1.6833954 1.6833954 2.6291199 3.966568 2.6291199 6.3472443l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m18.501312 177.50656l445.38583 1.0393677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m18.501312 177.50656l445.38583 1.0393677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m19.17323 455.2861l445.38583 1.0393677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m19.17323 455.2861l445.38583 1.0393677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m228.00626 367.65094l0 0c0 -4.9575195 4.01886 -8.976379 8.976364 -8.976379l0 0c2.3806915 0 4.663864 0.9457092 6.3472595 2.6291199c1.6833954 1.6833801 2.6291199 3.9665833 2.6291199 6.3472595l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575043 0 -8.976364 -4.01886 -8.976364 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m228.00626 367.65094l0 0c0 -4.9575195 4.01886 -8.976379 8.976364 -8.976379l0 0c2.3806915 0 4.663864 0.9457092 6.3472595 2.6291199c1.6833954 1.6833801 2.6291199 3.9665833 2.6291199 6.3472595l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575043 0 -8.976364 -4.01886 -8.976364 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m201.0 488.9922l0 0c0 -1.6525269 1.3396454 -2.9921875 2.9921875 -2.9921875l80.06287 0c0.7935791 0 1.554657 0.31524658 2.1158142 0.8764038c0.5611267 0.5611267 0.8763733 1.3222046 0.8763733 2.1157837l0 11.968384c0 1.6525269 -1.3396301 2.9921875 -2.9921875 2.9921875l-80.06287 0c-1.6525421 0 -2.9921875 -1.3396606 -2.9921875 -2.9921875z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m201.0 488.9922l0 0c0 -1.6525269 1.3396454 -2.9921875 2.9921875 -2.9921875l80.06287 0c0.7935791 0 1.554657 0.31524658 2.1158142 0.8764038c0.5611267 0.5611267 0.8763733 1.3222046 0.8763733 2.1157837l0 11.968384c0 1.6525269 -1.3396301 2.9921875 -2.9921875 2.9921875l-80.06287 0c-1.6525421 0 -2.9921875 -1.3396606 -2.9921875 -2.9921875z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m291.27036 302.34778l176.6929 0l0 131.93701l-176.6929 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m291.27036 302.34778l176.6929 0l0 131.93701l-176.6929 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m201.0 143.9764l0 0c0 -4.9575043 4.01886 -8.976364 8.976379 -8.976364l0 0c2.3806763 0 4.663849 0.9457092 6.3472595 2.6291199c1.6833954 1.6833954 2.6291199 3.966568 2.6291199 6.3472443l0 0c0 4.9575195 -4.018875 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m201.0 143.9764l0 0c0 -4.9575043 4.01886 -8.976364 8.976379 -8.976364l0 0c2.3806763 0 4.663849 0.9457092 6.3472595 2.6291199c1.6833954 1.6833954 2.6291199 3.966568 2.6291199 6.3472443l0 0c0 4.9575195 -4.018875 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m234.63779 143.9764l0 0c0 -4.9575043 4.01886 -8.976364 8.976379 -8.976364l0 0c2.3806915 0 4.663864 0.9457092 6.3472595 2.6291199c1.6833954 1.6833954 2.6291199 3.966568 2.6291199 6.3472443l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m234.63779 143.9764l0 0c0 -4.9575043 4.01886 -8.976364 8.976379 -8.976364l0 0c2.3806915 0 4.663864 0.9457092 6.3472595 2.6291199c1.6833954 1.6833954 2.6291199 3.966568 2.6291199 6.3472443l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m36.0 92.577484l0 0c0 -1.6525345 1.3396454 -2.9921799 2.9921875 -2.9921799l63.243973 0c0.7935791 0 1.5546494 0.31524658 2.115799 0.87638855c0.56114197 0.56114197 0.87638855 1.3222198 0.87638855 2.1157913l0 11.968391c0 1.6525345 -1.3396454 2.9921799 -2.9921875 2.9921799l-63.243973 0c-1.6525421 0 -2.9921875 -1.3396454 -2.9921875 -2.9921799z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m36.0 92.577484l0 0c0 -1.6525345 1.3396454 -2.9921799 2.9921875 -2.9921799l63.243973 0c0.7935791 0 1.5546494 0.31524658 2.115799 0.87638855c0.56114197 0.56114197 0.87638855 1.3222198 0.87638855 2.1157913l0 11.968391c0 1.6525345 -1.3396454 2.9921799 -2.9921875 2.9921799l-63.243973 0c-1.6525421 0 -2.9921875 -1.3396454 -2.9921875 -2.9921799z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m377.95276 92.577484l0 0c0 -1.6525345 1.3396301 -2.9921799 2.9921875 -2.9921799l63.243958 0c0.7935791 0 1.554657 0.31524658 2.1158142 0.87638855c0.5611267 0.56114197 0.8763733 1.3222198 0.8763733 2.1157913l0 11.968391c0 1.6525345 -1.3396301 2.9921799 -2.9921875 2.9921799l-63.243958 0c-1.6525574 0 -2.9921875 -1.3396454 -2.9921875 -2.9921799z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m377.95276 92.577484l0 0c0 -1.6525345 1.3396301 -2.9921799 2.9921875 -2.9921799l63.243958 0c0.7935791 0 1.554657 0.31524658 2.1158142 0.87638855c0.5611267 0.56114197 0.8763733 1.3222198 0.8763733 2.1157913l0 11.968391c0 1.6525345 -1.3396301 2.9921799 -2.9921875 2.9921799l-63.243958 0c-1.6525574 0 -2.9921875 -1.3396454 -2.9921875 -2.9921799z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m291.27036 406.65878l-43.023636 0l0 0c-23.761292 0 -43.02362 -17.464417 -43.02362 -39.007874c0 -21.543457 19.26233 -39.007874 43.02362 -39.007874l43.023636 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m291.27036 406.65878l-43.023636 0l0 0c-23.761292 0 -43.02362 -17.464417 -43.02362 -39.007874c0 -21.543457 19.26233 -39.007874 43.02362 -39.007874l43.023636 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m256.35696 367.65094l0 0c0 -4.9575195 4.01886 -8.976379 8.976379 -8.976379l0 0c2.3806763 0 4.663849 0.9457092 6.3472595 2.6291199c1.6833801 1.6833801 2.6291199 3.9665833 2.6291199 6.3472595l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m256.35696 367.65094l0 0c0 -4.9575195 4.01886 -8.976379 8.976379 -8.976379l0 0c2.3806763 0 4.663849 0.9457092 6.3472595 2.6291199c1.6833801 1.6833801 2.6291199 3.9665833 2.6291199 6.3472595l0 0c0 4.9575195 -4.01886 8.976379 -8.976379 8.976379l0 0c-4.9575195 0 -8.976379 -4.01886 -8.976379 -8.976379z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m309.5013 321.0l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m309.5013 321.0l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m344.91965 321.0l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m344.91965 321.0l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m380.33798 321.0l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m380.33798 321.0l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m309.5013 342.3604l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m309.5013 342.3604l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m344.91965 342.3604l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m344.91965 342.3604l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m380.33798 342.3604l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m380.33798 342.3604l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m309.5013 363.72083l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m309.5013 363.72083l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m344.91965 363.72083l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m344.91965 363.72083l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m380.33798 363.72083l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m380.33798 363.72083l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m309.5013 385.08124l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m309.5013 385.08124l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m344.91965 385.08124l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m344.91965 385.08124l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m380.33798 385.08124l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m380.33798 385.08124l25.259857 0l0 13.921265l-25.259857 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m427.20996 363.9344l0 0c0 -2.9049377 2.3549194 -5.2598267 5.259857 -5.2598267l0 0c1.394989 0 2.7328491 0.5541382 3.7192688 1.5405579c0.9864197 0.9864197 1.5405579 2.3242798 1.5405579 3.7192688l0 0c0 2.9049377 -2.354889 5.259857 -5.2598267 5.259857l0 0c-2.9049377 0 -5.259857 -2.3549194 -5.259857 -5.259857z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m427.20996 363.9344l0 0c0 -2.9049377 2.3549194 -5.2598267 5.259857 -5.2598267l0 0c1.394989 0 2.7328491 0.5541382 3.7192688 1.5405579c0.9864197 0.9864197 1.5405579 2.3242798 1.5405579 3.7192688l0 0c0 2.9049377 -2.354889 5.259857 -5.2598267 5.259857l0 0c-2.9049377 0 -5.259857 -2.3549194 -5.259857 -5.259857z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m334.76117 143.97636l0 0c0 -6.9753113 5.654602 -12.629913 12.629913 -12.629913l0 0c3.3496704 0 6.562134 1.3306427 8.930695 3.6992188c2.3685608 2.3685608 3.6992188 5.5810394 3.6992188 8.930695l0 0c0 6.9753113 -5.654602 12.629929 -12.629913 12.629929l0 0c-6.9753113 0 -12.629913 -5.6546173 -12.629913 -12.629929z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m334.76117 143.97636l0 0c0 -6.9753113 5.654602 -12.629913 12.629913 -12.629913l0 0c3.3496704 0 6.562134 1.3306427 8.930695 3.6992188c2.3685608 2.3685608 3.6992188 5.5810394 3.6992188 8.930695l0 0c0 6.9753113 -5.654602 12.629929 -12.629913 12.629929l0 0c-6.9753113 0 -12.629913 -5.6546173 -12.629913 -12.629929z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6d727",
    d: "m201.61417 206.27034l42.0 -42.0l42.0 42.0l-21.0 0l0 141.08662l-42.0 0l0 -141.08662z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1e1e1e",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m201.61417 206.27034l42.0 -42.0l42.0 42.0l-21.0 0l0 141.08662l-42.0 0l0 -141.08662z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1ElecHan);
export default __webpack_public_path__ + "static/media/s1-elec-han.a727d8956ce911e1de7c84706378d089.svg";
export { ForwardRef as ReactComponent };